module.exports = "<p>\n  Attiva online come socio e accedi a tanti vantaggi come sconti e punti in più sulla tua tessera:\n</p>\n<br>\n<ul>\n  <li>- Coop Alleanza 3.0, </li>\n  <li>- Unicoop Tirreno, </li>\n  <li>- Coop Reno</li>\n</ul>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dialogs/alg-socio-modal/alg-socio-modal.component.html
// module id = ./src/app/components/dialogs/alg-socio-modal/alg-socio-modal.component.html
// module chunks = main